<template>
  <v-alert type="info" text class="mt-3">
    <v-row>
      <v-col xl="auto" lg="auto" md="auto" sm="12" cols="12" align-self="center"
        >Configure um e-mail para recuperar seu acesso quando
        necessitar.</v-col
      >
      <v-col lg="auto" md="auto" xl="auto" sm="12" cols="12" align-self="center"
        ><v-btn
          small
          rounded
          color="info"
          class="white--text"
          @click="redirecionarConfigEmail()"
          >Configurar e-mail</v-btn
        ></v-col
      >
    </v-row>
  </v-alert>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations("usuario", ["setTabConta"]),
    redirecionarConfigEmail() {
      this.setTabConta(1);
      this.$router.push("minha-conta");
    },
  },
};
</script>

<style>
</style>